/******/ (() => {
/* eslint-disable */
if (!customElements.get('info-columns-product-atc')) {
  customElements.define(
    'info-columns-product-atc',
    class InfoColumnsProductAtc extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.variantInput = this.querySelector('[data-info-cols-variant-id]');
        this.priceEl = this.querySelector('[data-info-cols-price]');
        this.comparePriceEl = this.querySelector('[data-info-cols-compare-price]');
        this.compareWrap = this.querySelector('[data-info-cols-compare-wrap]');
        this.addButton = this.querySelector('[data-info-cols-atc-button]');
        this.addButtonText = this.querySelector('[data-add-to-cart-text]');
        if (this.addButtonText && !this.addButtonText.dataset.defaultLabel) {
          this.addButtonText.dataset.defaultLabel = this.addButtonText.textContent.trim();
        }
        this.soldOutText = this.dataset.soldOutText || 'Sold out';
        this.unavailableText = this.addButtonText?.getAttribute('data-unavailable-text') || 'Unavailable';

        const wethemeGlobal = document.querySelector('script#wetheme-global');
        if (wethemeGlobal) {
          try {
            this.moneyFormat = JSON.parse(wethemeGlobal.textContent).moneyFormat;
          } catch (e) {
            this.moneyFormat = '${{amount}}';
          }
        } else {
          this.moneyFormat = '${{amount}}';
        }

        eventBus.on('variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        eventBus.off('variant:change', this.onVariantChange);
      }

      handleVariantChange(context) {
        if (context.sectionId !== this.sectionId) return;
        if (!context.variant) {
          this.setUnavailable();
          return;
        }
        this.updateVariant(context.variant);
      }

      updateVariant(variant) {
        if (this.variantInput) {
          this.variantInput.value = variant.id;
          this.variantInput.disabled = !variant.available;
        }

        if (this.priceEl) {
          this.priceEl.textContent = this.formatVariantPrice(variant.price);
        }

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (this.compareWrap) {
          this.compareWrap.toggleAttribute('hidden', !onSale);
        }
        if (this.comparePriceEl && onSale) {
          this.comparePriceEl.textContent = this.formatVariantPrice(variant.compare_at_price);
        }

        if (this.addButton) {
          this.addButton.disabled = !variant.available;
        }

        if (this.addButtonText) {
          if (!variant.available) {
            this.addButtonText.textContent = this.soldOutText;
          } else {
            const defaultLabel = this.addButtonText.dataset.defaultLabel;
            this.addButtonText.textContent = defaultLabel || this.addButtonText.textContent;
          }
        }
      }

      setUnavailable() {
        if (this.variantInput) this.variantInput.disabled = true;
        if (this.addButton) this.addButton.disabled = true;
        if (this.addButtonText) this.addButtonText.textContent = this.unavailableText;
        if (this.priceEl) this.priceEl.textContent = this.unavailableText;
        if (this.compareWrap) this.compareWrap.setAttribute('hidden', '');
      }

      formatVariantPrice(cents) {
        if (window.wetheme?.formatMoney) {
          const formatted = window.wetheme.formatMoney(cents, this.moneyFormat);
          const tmp = document.createElement('div');
          tmp.innerHTML = formatted;
          return tmp.textContent || tmp.innerText;
        }
        return (cents / 100).toFixed(2);
      }
    }
  );
}
/******/ })();
